import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = { expandable: String };

  initialize() {
    this.expandableTypes.forEach((expandableType) => {
      this.records(expandableType).forEach((type) => {
        // eslint-disable-next-line
        type.hidden = true;
        if (Number(type.dataset.iterationCount) !== 1) return;
        this.element.insertBefore(this.template(expandableType), type);
      });
    });
  }

  expand(event) {
    event.preventDefault();
    const { eventTarget } = event.target.dataset;

    if (!this.expandableTypes.includes(eventTarget)) {
      // eslint-disable-next-line
      console.error('Undefined event type');
    }

    this.records(eventTarget).forEach((target) => {
      target.toggleAttribute('hidden');
    });
  }

  // Private

  records(target) {
    return this.element.querySelectorAll(`[data-type=${target}]`);
  }

  template(target) {
    const template = this.element.querySelector(`[data-template-id=${target}]`);
    return template.content.cloneNode(true);
  }

  get expandableTypes() {
    return this.expandableValue.split(',').map((item) => item.trim());
  }
}
